import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";
// namespace SlotGames {
	export class MayanHeroes_2Screen extends SlotGameType1_2Screen {
	
		
		//protected panelFactory: IPanelFactory = new MayanHeroesPanelFactory();
		protected override helpFactory: IHelpFactory = new MayanHeroesHelpFactory();
		//LED COLOR
		protected override ColorLed: string = "0,139,139\n";



		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "MayanHeroes");
			this.spinnableReelsParams.topBorderWidth = 6;
			this.spinnableReelsParams.bottomBorderWidth = 6;
		}

		// public PrepareFont(resourceManager: ResourceManager) {
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "." + this.resid.ScopedResourceName("font")));
		// 	resourceManager.Add(new FontResource(this.basepath + "resources/Monky Stone.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));
		// }
	}

	//Panel Colorized
	class MayanHeroesPanelFactory implements IPanelFactory {
		public CreateNewPanel(params: PanelParams): Panel {
			return new MayanHeroesPanel(params);
		}
	}

	class MayanHeroesPanel extends Panel {
		protected override ButtonBackground(): ButtonColors {
			let color: ButtonColors = {
				backgroundButtonColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor: "linear-gradient(to left , transparent, HoneyDew,transparent ) 0 10 100%",
			};
			return color;

		}

	}

	//Help Colorized
	class MayanHeroesHelpFactory implements IHelpFactory {
		public CreateNewHelp(params: HelpParameters): Help {
			return new MayanHeroesHelp(params);
		}
	}

	class MayanHeroesHelp extends Help {
		protected override BackgroundPanel(): HelpPanelColor {
			let color: HelpPanelColor = {
				backgroundPanelColor: "linear-gradient(rgb(31, 75, 60),rgb(40, 77, 71), rgb(103, 146, 139),rgb(40, 77, 71),rgb(31, 75, 60)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			};

			return color;
		}
	}


// }
